<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href="route_back">Плейлисты</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Создать плейлист</li>
        </ol>
    </nav>

    <div class="form-body">
        <div class="two-col-container">
            <div class="left-col">
                <div class="form-narrow mb-4">

                    <div class="form-check mb-4">
                        <input class="form-check-input" type="checkbox" value="" v-model="formData.default">
                        <label class="form-check-label">
                            Дефолтный плейлист
                        </label>
                    </div>

                    <div class="mb-4">
                        <div class="form-label">Клиент <span class="color-red">*</span></div>
                        <v-select
                            v-model="picked_client"
                            :items="clients"
                            item-title="name"
                            item-value="id"
                            variant="outlined"
                            color="primary"
                            density="compact"
                            clearable
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>

                    <div class="mb-4">
                        <div class="form-label">Бренд <span class="color-red">*</span></div>
                        <v-select
                            v-model="picked_brand"
                            :items="brands"
                            item-title="name"
                            item-value="id"
                            variant="outlined"
                            color="primary"
                            density="compact"
                            clearable
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>

                    <div class="mb-4">
                        <div class="form-label">Тип устройства <span class="color-red">*</span></div>
                        <v-select
                            :disabled="!picked_client && !client_id && !picked_brand && !picked_brand"
                            v-model="picked_device_type"
                            :items="deviceTypes"
                            item-title="name"
                            item-value="id"
                            variant="outlined"
                            color="primary"
                            density="compact"
                            clearable
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>

                    <div class="mb-4">
                        <label for="playlist-name" class="form-label">
                            Название плейлиста <span class="color-red">*</span>
                        </label>
                        <input type="text" class="form-control"
                               ref="playlistName"
                               id="playlist-name"
                               v-model="formData.name">
                    </div>

                    <div class="d-flex-col justify-content-beetween mb-4">
                        <label for="playlist-interval" class="form-label">
                            Диапазон показа <span class="color-red">*</span>
                        </label>
                        <DateTimePicker id="playlist-interval"
                            :enableTimePicker="true"
                            :range="true"
                            :minDate="minDate"
                            @updateValue="handleDateTime"
                        />
                    </div>
                </div>

                <div class="form-narrow">
                    <div class="mb-3">
                        <div class="tabs mb-2 ">
                            <div class="tabs__ctrls">
                                <button
                                    class="reset-btn tabs__ctrl local"
                                    v-on:click.prevent="devices_by = 1"
                                    :class="{ 'is-selected': devices_by === 1 }"
                                    type="button">
                                    Устройства
                                </button>
                                <button
                                    class="reset-btn tabs__ctrl cloud"
                                    v-on:click.prevent="devices_by = 0"
                                    :class="{ 'is-selected': devices_by === 0 }"
                                    type="button">
                                    Группы устройств
                                </button>
                                <button
                                    class="reset-btn tabs__ctrl cloud"
                                    v-on:click.prevent="devices_by = 2"
                                    :class="{ 'is-selected': devices_by === 2 }"
                                    type="button">
                                    Регион
                                </button>
                            </div>
                        </div>

                        <template v-if="devices_by === 0">
                            <div class="mb-4 mt-4">
                                <v-select
                                    :disabled="picked_client && picked_brand && picked_device_type ? false : true"
                                    v-model="formData.group_ids"
                                    :items="groups"
                                    item-title="name"
                                    item-value="id"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    clearable
                                    multiple>
                                    <template #no-data>
                                        <v-list-item>
                                            <span>Данные не найдены</span>
                                        </v-list-item>
                                    </template>
                                    <template #selection="{ item, index }">
                                        <v-chip v-if="index < 3" :text="item.title"></v-chip>
                                        <span v-if="index === 3" class="text-grey text-caption align-self-center">
                                            + еще {{ formData.group_ids.length - 3 }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </template>
                        <template v-if="devices_by === 1">
                            <div class="mb-4 mt-4 tabs-content">
                                <select-back-searchable-element
                                    ref="backSearchable"
                                    @getItems="loadDevices"
                                    @syncItems="syncDevices"
                                    :mountedGetItems="false"
                                    :backSearchableDisabled="picked_client && picked_brand ? false : true"
                                    :loaded_items="devices_founded"
                                    :picked_items="formData.device_ids"
                                    :pages="devices_pages">
                                </select-back-searchable-element>
                            </div>
                        </template>

                        <template v-if="devices_by === 2">
                            <div class="mb-4 mt-4">
                                <v-select
                                    :disabled="picked_client && picked_brand && picked_device_type ? false : true"
                                    v-model="formData.region_ids"
                                    :items="regions"
                                    item-title="name"
                                    item-value="id"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    clearable
                                    multiple>
                                    <template #no-data>
                                        <v-list-item>
                                            <span>Данные не найдены</span>
                                        </v-list-item>
                                    </template>
                                    <template #selection="{ item, index }">
                                        <v-chip v-if="index < 3" :text="item.title"></v-chip>
                                        <span v-if="index === 3" class="text-grey text-caption align-self-center">
                                            + еще {{ formData.region_ids.length - 3 }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </template>

                        <div v-if="picked_device_type == cashier_type_id" class="mb-4">
                            <label class="form-label">Формат отображения(только для типа ус-в МК)</label>
                            <div v-for="format in playlist_display_formats" class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input"
                                           type="radio"
                                           :value="format.id"
                                           v-model="formData.playlist_display_format">
                                    {{ format.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <timeline-element
                    :contents="contents"
                    @contentDir="loadDir"
                    @syncContent="syncContent"
                    :itemsFromFolder="itemsFromFolder"
                    :opener="opener"
                    :domain="domain">
                </timeline-element>

                <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
                    <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createPlaylist"/>
                    <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
                </div>
            </div>

            <Transition name="fade">
                <div v-if="showSelectedDevices" class="right-col">
                    <SelectedDevices
                        :devicesFounded="devices_founded"
                        :devicesTypeId="picked_device_type"
                        v-model:addedDevicesIds="formData.device_ids"
                        v-model:groupIds="formData.group_ids"
                        v-model:regionIds="formData.region_ids"
                        @stateChange="handleSelectedDevicesState"
                    />
                </div>    
            </Transition>
        </div>
    </div>

    <Alert />
</template>

<script>
import Playlist from "../../../../models/Playlist";
import TimelineElement from "../../../../elements/TimelineElement.vue";
import Content from "../../../../models/Content";
import SelectBackSearchableElement from "../../../../elements/SelectBackSearchableElement.vue";
import axios from 'axios'
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import DateTimePicker from "../../../../elements/DateTimePicker.vue";
import SelectedDevices from "../../../../elements/SelectedDevices.vue";

export default {
    name: 'PlaylistCreateComponent',
    components: {
        SelectBackSearchableElement,
        TimelineElement,
        Alert,
        ConfirmBtn,
        DateTimePicker,
        SelectedDevices
    },
    props: {
        route_back: String,
        route_client_search: String,
        route_brand_search: String,
        route_device_groups_search: String,
        route_devices_search: String,
        route_content_list: String,
        route_create: String,
        route_dir_content: String,
        route_get_regions: String,
        route_device_types: String,
        cashier_type_id: Number,
        domain: String,
        client_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            playlist: new Playlist({
                route_create: this.route_create,
                route_brand_search: this.route_brand_search,
                route_client_search: this.route_client_search,
                route_device_groups_search: this.route_device_groups_search,
                route_devices_search: this.route_devices_search,
                route_device_types_search: this.route_device_types,
            }),
            content: new Content({
                route_list: this.route_content_list,
                route_dir_content: this.route_dir_content,
            }),
            playlist_display_formats: [
                {
                    id: 1,
                    name: 'Вертикальный'
                },
                {
                    id: 2,
                    name: 'Горизонтальный'
                }
            ],
            minDate: new Date().toISOString().split('T')[0],
            devices_by: 1,
            clients: [],
            brands: [],
            groups: [],
            regions: [],
            deviceTypes: [],
            contents: [],
            devices_founded: [],
            itemsFromFolder: [],

            picked_client: undefined,
            picked_brand: undefined,
            picked_device_type: undefined,

            opener: '',

            devices_pages: 1,
            formData: {
                client_id: 0,
                brand_id: 0,
                device_type_id: null,
                name: '',
                start: '',
                end: '',
                group_ids: [],
                device_ids: [],
                region_ids: [],
                time_start: '',
                time_end: '',
                default: false,
                contents: [],
                playlist_display_format: '',
            },

            loading: false,
            showSelectedDevices: false,
        };
    },
    computed: {
        devicesSelected() {
            if (this.formData.device_ids.length || this.formData.group_ids.length || this.formData.region_ids.length) return true;
            else return false;
        }
    },
    watch: {
        picked_client: function () {
            this.formData.client_id = this.picked_client;
            this.picked_brand = undefined;
            this.searchBrands();
        },
        picked_brand: function () {
            this.formData.brand_id = this.picked_brand;
            this.loadDevices('', 9999, 1);
            this.getContent();
        },
        picked_device_type: function () {
            this.formData.device_type_id = this.picked_device_type;
            this.formData.group_ids = [];
            this.getRegions();
            this.searchGroups();
            this.loadDevices('', 9999, 1);
            this.clearDevices();
        },
        devicesSelected(val) {
            if (val) {
                this.showSelectedDevices = true;
            }
        },
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        setDateEnd: async function (e) {
            const $selectedDateFrom = new Date(e.target.value);
            $selectedDateFrom.setDate($selectedDateFrom.getDate());
            const $date = $selectedDateFrom.toISOString().slice(0, 10);
            document.getElementById('playlist-date-end').setAttribute('min', $date);
            document.getElementById('playlist-date-end').value = '';
        },
        syncDevices: function (devices) {
            this.formData.device_ids = devices;
        },
        loadDevices: async function (search, limit, page) {
            let data = await this.playlist.devices({
                search: search,
                limit: limit,
                page: page,
                client_id: this.picked_client,
                brand_id: this.picked_brand,
                device_type_id: this.picked_device_type
            });
            this.devices_founded = data.items;
            this.devices_pages = data.pages;
        },
        syncContent: function (list) {
            this.formData.contents = list;
        },
        getContent: async function () {
            let response = await this.content.loadTable(1, 1000, '', {
                client_id: this.formData.client_id,
                brand_id: this.formData.brand_id
            });
            this.contents = response.items;
        },
        getRegions: async function () {
            let data = await axios.get(this.route_get_regions, {
                params: {
                    limit: 9999
                }
            });
            this.regions = data.data.items;
        },
        getDeviceTypes: async function() {
            let deviceTypes = await this.playlist.deviceTypes();
            this.deviceTypes = deviceTypes.items;
        },
        createPlaylist: async function () {
            switch (this.devices_by) {
                case 0:
                    this.formData.device_ids = [];
                    this.formData.region_ids = [];
                    break;
                case 1:
                    this.formData.group_ids = [];
                    this.formData.region_ids = [];
                    break;
                case 2:
                    this.formData.device_ids = [];
                    this.formData.group_ids = [];
                    break;
            }

            if (!this.picked_client) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }

            if (!this.picked_brand) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите бренд!' });
                this.toggleLoading();
                return;
            }

            if (!this.picked_device_type) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите тип устройства!' });
                this.toggleLoading();
                return;
            }

            if (this.$refs.playlistName.value === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название плейлиста!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.start === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите дату начала показа!' });
                this.toggleLoading();
                return;
            }

            if (new Date().setHours(0, 0, 0, 0) > new Date(new Date(this.formData.start))) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Дата начала показа не может быть меньше текущей даты!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.end === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите дату окончания показа!' });
                this.toggleLoading();
                return;
            }

            if (new Date().setHours(0, 0, 0, 0) > new Date(new Date(this.formData.end))) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Дата окончания показа не может быть меньше текущей даты!' });
                this.toggleLoading();
                return;
            }

            if (!this.formData.device_ids.length && !this.formData.group_ids.length && !this.formData.region_ids.length) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте хотя бы одно устройство, группу или регион!' });
                this.toggleLoading();
                return;
            }

            this.loading = true;

            let result = await this.playlist.create(this.formData);
            if (result) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: window.lastResponse.data.message });
                this.toggleLoading();
            }
        },
        searchClients: async function () {
            let clients = await this.playlist.clients();
            this.clients = clients.items;
        },
        searchGroups: async function () {
            let groups = await this.playlist.deviceGroups({
                client_id: this.picked_client,
                brand_id: this.picked_brand,
                device_type_id: this.picked_device_type
            });
            this.groups = groups.items;
        },
        searchBrands: async function () {
            let brands = await this.playlist.brands({
                client_id: this.picked_client
            });
            this.brands = brands.items;
        },
        loadDir: async function (item) {
            if (item.type == 2) {
                this.opener = event.target.getAttribute('data-name')
                let result = await this.content.loadDir(item.id);
                item.content = result.items;
                this.itemsFromFolder = item.content
                item.openned = true
                if (this.opener !== 'opener') {
                    for (let element of item.content) {
                        if (element.type != 2) {
                            element.selected = true
                        }
                    }
                }
                return result
            }
        },
        interceptResponse() {
            window.lastResponse = null;
            axios.interceptors.response.use(response => {
                window.lastResponse = response;
                return response;
            }, error => {
                window.lastResponse = error.response;
                return Promise.reject(error);
            });
        },
        clearDevices() {
            if (this.$refs.backSearchable) this.$refs.backSearchable.clearDevices();
        },
        handleDateTime(value) { // обработка данных из DateTimePicker
            this.formData.start = value.date.start;
            this.formData.end = value.date.end;
            this.formData.time_start = value.time.start;
            this.formData.time_end = value.time.end;
        },
        handleSelectedDevicesState(state) {
            this.showSelectedDevices = state;
        }
    },
    mounted() {
        this.searchClients();
        this.getDeviceTypes();
        this.interceptResponse();
    }
};
</script>

<style scoped>
.tabs-content > * {
    margin-top: 0 !important;
    margin-bottom:0 !important;
}
</style>
